












import Vue from 'vue';
import events from './events';

export default Vue.extend({
  name: 'LoadingPlugin',
  data() {
    return {
      value: false,
    };
  },
  mounted() {
    events.$on('set-state', (state: boolean) => {
      this.value = state;
    });
    events.$on('show', (state: boolean) => {
      this.value = true;
    });
    events.$on('hide', (state: boolean) => {
      this.value = false;
    });
  },
  methods: {
    show(state: boolean): void {
      this.value = state;
    },
  },
});
